import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SearchState {
  query: string;
}

const initialState: SearchState = {
  query: "",
};

const searchSlice = createSlice({
  name: "searchSlice",
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export default searchSlice.reducer;
export const { setSearchQuery } = searchSlice.actions;
